import React from "react";
import { Link, useLocation } from "react-router-dom";
import sitedata from "../../sitedetails.json";
import {ImExit} from 'react-icons/im'
import { useDispatch } from "react-redux";
import { logoutAction } from "../../redux/actions/userAction";
const AdminSidebar = () => {
  // const path = '/admin/dashboard'
  const urlpath = useLocation()
  // console.log(urlpath)
 const onselected = " text-[#EA4E74] rounded-md font-semibold"
 const dispatch = useDispatch()
  const logoutHandler = () => {
    dispatch(logoutAction())
  }

  return (
    <>
      <div className="bg-brand_offwhite text-brand_offblue font-semibold font-source h-full py-[60px] flex flex-col gap-9 items-center justify-between  w-[350px]">
        <div className="flex flex-col gap-9 items-center">
          <Link to ='/'>{sitedata.brand_name}</Link>
          <Link to="/admin/dashboard" className={ `${ '/admin/dashboard' === urlpath.pathname ? onselected : ''}` } >
            <h1>Dashboard</h1>{" "}
          </Link>
          <Link to="/admin/createcourse" className={ `${ '/admin/createcourse' === urlpath.pathname ? onselected : ''}` }  >
            <h1>Create Course</h1>{" "}
          </Link>
          <Link to="/admin/courses" className={ `${ '/admin/courses' === urlpath.pathname ? onselected : ''}` } >
            <h1>Courses</h1>{" "}
          </Link>
          <Link to="/admin/users" className={ `${ '/admin/users' === urlpath.pathname ? onselected : ''}` } >
            <h1>Users</h1>{" "}
          </Link>
          <button onClick={() =>{logoutHandler() }} className="flex items-center"><h1 className="underline px-2 font-semibold">Logout</h1> <ImExit/></button> 
          
        </div>
        
      </div>
    </>
  );
};

export default AdminSidebar;
